/*======================================================================================
*
*
*    Base Controller
*
*
======================================================================================*/

import ExampleController from './ExampleController';
import HomeController from './HomeController';
import ProductController from './ProductController';
import CartController from './CartController';
import CategoryController from './CategoryController';
import ContactController from "./ContactController";
import LoginController from "./LoginController";
import RegisterController from "./RegisterController";
import PasswordResetController from "./PasswordResetController";
import PasswordResetConfirmationController from "./PasswordResetConfirmationController";
import ProfileController from "./ProfileController";
import ProductUploadController from "./ProductUploadController";
import AboutController from "./AboutController";
import NegotiationController from "./NegotiationController";
import ProductsForSaleController from "./ProductsForSaleController";
import NotFinishedProductsUploadController from "./NotFinishedProductsUploadController";
import VerifyProductController from "./VerifyProductController";
import ProductHistoryController from "./ProductHistoryController";
import ProductUploadLandingController from "./ProductUploadLandingController";

export default {
    Example: ExampleController,
    Home: HomeController,
    Product: ProductController,
    Cart: CartController,
    Category: CategoryController,
    Contact: ContactController,
    Login: LoginController,
    Register: RegisterController,
    PasswordReset: PasswordResetController,
    PasswordResetConfirmation: PasswordResetConfirmationController,
    Profile: ProfileController,
    About: AboutController,
    ProductUpload: ProductUploadController,
    Negotiation: NegotiationController,
    ProductsForSale: ProductsForSaleController,
    NotFinishedProductsUpload: NotFinishedProductsUploadController,
    VerifyProduct: VerifyProductController,
    ProductHistory: ProductHistoryController,
    ProductUploadLanding: ProductUploadLandingController
};
